<template>
  <v-container fluid>
    <v-card class="mb-4">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('gameVersions.listTitle')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="$t('general.search')"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-card-title>
      <data-table
        :items="$store.state.gameVersions.list"
        :headers="$store.getters['gameVersions/headers']"
        :loading="$store.state.gameVersions.loading"
        :search="search"
        @selected="(value) => selected = value"
        @edit="editSelection"
      ></data-table>
    </v-card>
    <v-fab-transition>
      <v-btn v-if="showAddButton" fab dark color="primary" bottom right fixed @click.native="addDialog = true">
        <v-icon dark>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        fab
        dark
        color="red"
        bottom
        right
        fixed
        @click.native="deleteDialog = true"
        style="right: 80px;"
        v-if="selected.length > 0"
        >
        <v-icon dark>delete</v-icon>
      </v-btn>
    </v-fab-transition>
    <game-version-add :active="addDialog" @closedialog="addDialog = false;"></game-version-add>
    <confirmation-dialog :active="deleteDialog" title="Confirmation ?" :message="$tc('gameVersions.deleteConfirmation', selected.length, {count: selected.length})" :loading="$store.state.gameVersions.loading" @confirmation="deleteGameVersions" @cancel="deleteDialog = false"></confirmation-dialog>
  </v-container>
</template>
<script>
import DataTable from "@/components/DataTable";
import GameVersionAdd from "./GameVersion-add"
import ConfirmationDialog from "@/components/ConfirmationDialog"
export default {
  name: "GameVersions",
  components: {
    DataTable,
    GameVersionAdd,
    ConfirmationDialog
  },
  data() {
    return {
      showAddButton: false,
      search: "",
      selected: [],
      editDialog: false,
      addDialog: false,
      deleteDialog: false,
      gameVersionId: ""
    };
  },
  mounted() {
    this.$store.dispatch("gameVersions/getAll");
    setTimeout(() => this.showAddButton = true, 500)
  },
  methods: {
    editSelection(value) {
      this.$router.push('/game-versions/' + value + '/companies')
    },
    async deleteGameVersions() {
      if (await this.$store.dispatch("gameVersions/delete", this.selected.map(item => item._id))){
        this.deleteDialog = false
        this.selected = []
      }
    }
  },
  computed: {}
};
</script>
